export const shallowCompareObjects = (obj1: any, obj2: any) => {
  if (obj1 === obj2) return true;
  if (
    typeof obj1 !== "object" ||
    typeof obj2 !== "object" ||
    obj1 === null ||
    obj2 === null
  ) {
    return false;
  }

  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  if (keys1.length !== keys2.length) return false;

  return keys1.every(
    (key) => obj2.hasOwnProperty(key) && obj1[key] === obj2[key]
  );
};

export const encodeSearchListingFilters = (list: any) => {
  return list.map((item: any) => encodeURIComponent(item)).join(",");
};

export const decodeSearchListingFilters = (arrayString: string) =>
  arrayString
    ? arrayString.split(",").map((item) => Number(decodeURIComponent(item)))
    : [];
